
/**
 * Resolves an individual access token by calling the backend endpoint.
 * @param {string} token - The token to resolve.
 * @param {string} prefix - The API base URL.
 * @returns {Promise<Object>} - The response from the backend.
 */
const resolveIndividualAccessToken = async (token, prefix) => {
  const url = `${prefix}auth/links/token/resolve`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    });
    return await response.json();
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export default resolveIndividualAccessToken;